import { jsx as _jsx } from "react/jsx-runtime";
import { ExpansionTableExpansionRow } from '../../ExpansionTableExpansionRow';
export const getRenderExpansionRowElement = ({ rowKeyExtractor, rowHeaderTestId, renderDetail, renderLeftRowElement, getHasRowDetail, columns, hasAllRowsExpanded, tableHasDetail, expandedKey, setExpandedKey, }) => {
    return (row) => {
        const rowKey = rowKeyExtractor(row);
        const isExpanded = expandedKey === rowKey || hasAllRowsExpanded;
        const showRenderedDetail = isExpanded && renderDetail;
        const detail = showRenderedDetail ? renderDetail(row) : undefined;
        const handleExpandedChange = () => setExpandedKey(isExpanded ? undefined : rowKey);
        const showIconPlaceholder = tableHasDetail && getHasRowDetail
            ? !getHasRowDetail(row)
            : !tableHasDetail;
        const leftRowElement = renderLeftRowElement?.(rowKey);
        return (_jsx(ExpansionTableExpansionRow, { id: rowKey, columns: columns, row: row, detail: detail, leftRowElement: leftRowElement, headerTestId: rowHeaderTestId, hasAllRowsExpanded: hasAllRowsExpanded, tableHasDetail: tableHasDetail, showIconPlaceholder: showIconPlaceholder, onHeaderClick: handleExpandedChange }, rowKey));
    };
};
